import styled from 'styled-components';
import { BaseLoadingMessage } from './masterBase/styles';

export const StateMensage = styled.div`

`;

// Using base component for loading message
export const LoadingMessage = BaseLoadingMessage;
